import React from 'react';
import { Info } from 'lucide-react';
import { Popover, PopoverContent, PopoverTrigger } from './ui/popover';

/**
 * Small ⓘ button that reveals explanatory text in a popover. Tap-to-open
 * (a Popover, not a Tooltip) so it works on touch screens, where hover
 * tooltips never appear. Use it to keep help text out of the way on
 * space-constrained screens.
 */
export function InfoTip({ children, label = 'More information', className = '', testId }) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          aria-label={label}
          className={`inline-flex h-6 w-6 items-center justify-center rounded-full text-slate-400 hover:text-slate-700 hover:bg-slate-100 focus:outline-none focus:ring-2 focus:ring-slate-300 ${className}`}
          data-testid={testId}
        >
          <Info className="h-4 w-4" />
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-72 max-w-[calc(100vw-2rem)] text-sm text-slate-700 leading-relaxed">
        {children}
      </PopoverContent>
    </Popover>
  );
}

export default InfoTip;
